<template>
    <el-dialog :width="goodsType == 'custom' ? '620px' : goodsType == 'stock' ? '620px' : goodsType == 'basic' ? '980px' : '620px'" title="产品详情" :before-close="handleClickCancel" class="ordinary_dialog" :close-on-press-escape="false"
               :close-on-click-modal="false" :visible.sync="productDetailVisible" append-to-body>
        <div class="ordinary_edit_wrap ordinary_detail_wrap" v-loading="loading">
            <el-form size="small" ref="productForm" label-position="top"  >

                <template v-if="goodsType == 'custom' || goodsType == 'stock'">
                    <el-form-item label="产品名称" prop="goods_name">
                        <div class="field_name" v-text="productDetail.product_name || '-'"></div>
                    </el-form-item>
                    <el-form-item label="产品图片" prop="image">
                        <div class="image_outer_wrap">
                            <ul  class="upload_image_list">
                                <li v-for="(item,index) in productDetail.image"  :key="index"  class="upload_image_item">
                                    <el-image :preview-src-list="productDetail.image.map(img=>img)" :src="item"  fit="cover"></el-image>
                                </li>
                            </ul>
                        </div>
                    </el-form-item>
                    <el-form-item label="计量单位" prop="unit">
                        <div class="field_name" v-text="productDetail.unit ? productDetail.unit : '--'"></div>
                    </el-form-item>

                    <el-form-item label="是否需要出入库" prop="can_in_out_stock" v-if="goodsType == 'custom'">
                        <div class="field_name" v-text="productDetail.can_in_out_stock ? '是' : '否'"></div>
                    </el-form-item>

                    <el-form-item label="产品描述" prop="description">
                        <div class="field_name" v-text="productDetail.description ? productDetail.description : '--'"></div>
                    </el-form-item>
                    <el-form-item label="成本价" prop="cost_price">
                        <div class="field_name" v-text="productDetail.cost_price"></div>
                    </el-form-item>
                    <el-form-item label="产品别名" prop="goods_name">
                        <div class="field_name" v-text="productDetail.goods_name || '-'"></div>
                    </el-form-item>
                    <el-form-item label="是否可销售" prop="goods_name">
                        <div class="field_name" v-text="productDetail.is_sale == 1 ? '是' : '否'"></div>
                    </el-form-item>
                    <el-form-item label="销售指导价" prop="goods_name">
                        <div class="field_name" v-text="productDetail.sale_price"></div>
                    </el-form-item>
                    <el-form-item label="是否可租借" prop="goods_name">
                        <div class="field_name" v-text="productDetail.is_lease == 1 ? '是' : '否'"></div>
                    </el-form-item>
                    <el-form-item label="租借指导价" prop="goods_name">
                        <div class="field_name" v-text="productDetail.lease_price"></div>
                    </el-form-item>

                </template>

                <template v-if="goodsType == 'basic'">
                    <el-row :gutter="20" type="flex">
                        <el-col :span="12">
                            <el-form-item label="产品名称" prop="goods_name">
                                <div class="field_name" v-text="productDetail.goods_name"></div>
                            </el-form-item>
                        </el-col>
                        <el-col :span="12">
                            <el-form-item label="产品品牌" prop="brand_name">
                                <div class="field_name" v-text="productDetail.brand_name ? productDetail.brand_name : '--'"></div>
                            </el-form-item>
                        </el-col>

                    </el-row>
                    <el-row :gutter="20" type="flex">
                        <el-col :span="12">
                            <el-form-item label="计量单位" prop="unit">
                                <div class="field_name" v-text="productDetail.unit ? productDetail.unit :'--'"></div>
                            </el-form-item>
                        </el-col>
                    </el-row>
                    <el-row :gutter="20" type="flex">
                        <el-col :span="12">
                            <el-form-item label="产品描述" prop="description">
                                <div class="field_name" v-text="productDetail.description ? productDetail.description : '--'"></div>
                            </el-form-item>
                        </el-col>
                    </el-row>
                    <div class="custom_title"><span>产品规格明细</span></div>
                    <el-table class="custom_table" :data="productDetail.skus" border row-key="product_name">
                        <el-table-column label="规格明细" prop="product_name" width="120">
                            <template slot-scope="{row}">
                                <div style="font-size: 14px;color: rgba(102, 102, 102, 1);line-height: 22px" >
                                    <p v-for="item in row.specs">{{item.spec}}:{{item.spec_value}}</p>
                                </div>
                            </template>
                        </el-table-column>
                        <el-table-column label="产品别名" prop="goods_name"></el-table-column>
                        <el-table-column label="成本价" align="right" prop="cost_price" width="95" class-name="tableInputColumn">
                            <template slot-scope="{row}">
                               <span v-text="row.cost_price ? '￥'+row.cost_price : '--'"></span>
                            </template>
                        </el-table-column>
                        <el-table-column label="是否可销售" prop="is_sale" width="95" >
                            <template slot-scope="{row}">
                                <span v-text="row.is_sale == 1 ? '是' : '否'"></span>
                            </template>
                        </el-table-column>
                        <el-table-column label="销售指导价" align="right" prop="sale_price" width="95">
                            <template slot-scope="{row}">
                                <span v-text="row.sale_price ? '￥'+row.sale_price : '--'"></span>
                            </template>
                        </el-table-column>
                        <el-table-column label="是否可租借" prop="is_lease" width="95">
                            <template slot-scope="{row}">
                               <span v-text="row.is_lease == 1 ? '是' : '否'"></span>
                            </template>
                        </el-table-column>
                        <el-table-column label="租借指导价" align="right" prop="lease_price" width="95">
                            <template slot-scope="{row}">
                                <span v-text="row.lease_price ? '￥'+row.lease_price : '--'"></span>
                            </template>
                        </el-table-column>
                    </el-table>


                </template>

                <template v-if="goodsType == 'bundle'">
                    <div class="custom_title"><span>基本信息</span></div>
                    <el-form-item label="产品名称" prop="goods_name">
                        <div class="field_name" v-text="productDetail.goods_name"></div>
                    </el-form-item>
                    <el-form-item label="产品图片" prop="image">
                        <div class="image_outer_wrap">
                            <ul  class="upload_image_list">
                                <li v-for="(item,index) in productDetail.image"  :key="index"  class="upload_image_item">
                                    <el-image :preview-src-list="productDetail.image.map(img=>img)" :src="item"  fit="cover"></el-image>
                                </li>
                            </ul>
                        </div>
                    </el-form-item>
                    <el-form-item label="产品描述" prop="description">
                        <div class="field_name" v-text="productDetail.description ? productDetail.description : '--'"></div>
                    </el-form-item>
                    <el-form-item label="是否可销售" prop="goods_name">
                        <div class="field_name" v-text="productDetail.is_sale == 1 ? '是' : '否'"></div>
                    </el-form-item>
                    <el-form-item label="是否可租借" prop="goods_name">
                        <div class="field_name" v-text="productDetail.is_lease == 1 ? '是' : '否'"></div>
                    </el-form-item>

                    <div class="custom_title"><span>配置信息</span></div>

                    <div class="skus_detail">
                        <ul>
                            <li v-for="item in productDetail.part">
                                <div class="top">
                                    <div class="ellipsis">部位名称：{{item.part_name}}</div>
                                    <span class="handle_icon_wrap" @click="item.is_down_up = !item.is_down_up">
                                        <i :class="item.is_down_up ? 'el-icon-caret-bottom' : 'el-icon-caret-left'" ></i>
                                    </span>
                                </div>
                                <div class="bottom" v-if="item.is_down_up">
                                   <el-table class="custom_table" :data="item.type == 'basic' ? item.goods_list[0].skus : item.goods_list" border row-key="product_name">
                                       <el-table-column label="产品名称" prop="goods_name" ></el-table-column>
<!--                                       <el-table-column label="成本价" prop="cost_price" width="95" class-name="tableInputColumn">-->
<!--                                           <template slot-scope="{row}">-->
<!--                                               <el-input class="text_align_right" @blur="handleBlurPrice(row,'cost_price')" v-model="row.cost_price" placeholder="请输入"></el-input>-->
<!--                                           </template>-->
<!--                                       </el-table-column>-->
<!--                                       <el-table-column label="销售指导价" prop="sale_price" width="95" class-name="tableInputColumn">-->
<!--                                           <template slot-scope="{row}">-->
<!--                                                <el-input class="text_align_right" @blur="handleBlurPrice(row,'sale_price')" v-model="row.sale_price" placeholder="请输入"></el-input>-->
<!--                                           </template>-->
<!--                                       </el-table-column>-->
<!--                                       <el-table-column label="租借指导价" prop="lease_price" width="95" class-name="tableInputColumn">-->
<!--                                           <template slot-scope="{row}">-->
<!--                                                 <el-input class="text_align_right" @blur="handleBlurPrice(row,'lease_price')" v-model="row.lease_price" placeholder="请输入"></el-input>-->
<!--                                           </template>-->
<!--                                       </el-table-column>-->
                                   </el-table>
                                </div>
                            </li>
                        </ul>
                    </div>


                </template>
            </el-form>
        </div>
<!--        <div slot="footer" v-if="goodsType == 'bundle'">-->
<!--            <el-button size="small" :disabled="BtnDisabled" @click="handleClickCancel">取消</el-button>-->
<!--            <el-button size="small" type="primary" :disabled="BtnDisabled" @click="handleClickConfirm">提交</el-button>-->
<!--        </div>-->
    </el-dialog>
</template>
<script>
import { GoodsCustomProductDetail, GoodsStockProductDetail, GoodsBasicProductDetail, GoodsBundleProductDetail} from '@/api'
export default {
    name: 'product_detail',
    props: {
        productDetailVisible: {
            type: Boolean,
            default: false,
        },
        goodsId: {
            type: Number,
            default: 0,
        },
        goodsType: {
            type: String,
            default: '',
        },

    },
    data() {
        return {
            BtnDisabled:false,
            loading:false,
            productDetail:{},
        }
    },
    created() {
        if(this.goodsId){
            this.getGoodsDetail()
        }
    },
    computed: {

    },
    mounted() {

    },
    methods: {
        getGoodsDetail(){
            let postData = {
                goods_id : this.goodsId
            }
            this.loading = true
            if(this.goodsType == 'stock'){
                GoodsStockProductDetail(postData).then(res => {
                    if (res.code === 200) {
                        this.productDetail = res.data
                        this.productDetail.image = this.productDetail.image ?  this.productDetail.image : []
                    }
                    this.loading = false
                })
            }else if(this.goodsType == 'custom'){
                GoodsCustomProductDetail(postData).then(res => {
                    if (res.code === 200) {
                        this.productDetail = res.data
                        this.productDetail.image = this.productDetail.image ?  this.productDetail.image : []
                    }
                    this.loading = false
                })
            }else if(this.goodsType == 'basic'){
                GoodsBasicProductDetail(postData).then(res => {
                    if (res.code === 200) {
                        this.productDetail = res.data
                        this.productDetail.image = this.productDetail.image ?  this.productDetail.image : []
                    }
                    this.loading = false
                })
            }else if(this.goodsType == 'bundle'){
                GoodsBundleProductDetail(postData).then(res => {
                    if (res.code === 200) {
                        this.productDetail = res.data
                        this.productDetail.image = this.productDetail.image ?  this.productDetail.image : []
                        this.productDetail.part.forEach((item)=>{
                            this.$set(item,'type',item.goods_list ? item.goods_list[0].type : '')
                            this.$set(item,'is_down_up',false)
                            // if(item.type == 'basic'){
                            //     item.goods_list[0].skus.forEach((child)=>{
                            //         this.$set(child,'cost_price','0.00')
                            //         this.$set(child,'sale_price','0.00')
                            //         this.$set(child,'lease_price','0.00')
                            //     })
                            // }else{
                            //     item.goods_list.forEach((child)=>{
                            //         this.$set(child,'cost_price','0.00')
                            //         this.$set(child,'sale_price','0.00')
                            //         this.$set(child,'lease_price','0.00')
                            //     })
                            // }
                        })
                    }
                    this.loading = false
                })
            }
        },
        handleBlurPrice(row,field){
            let price = row[field].replace(',', '')
            price = row[field].replace(/[^\d.]/g, '')
            if(price < 0){
                row[field] = 0
            }
            price = Number(price).toFixed(2)
            row[field] =  Number(price).toLocaleString(undefined, {minimumFractionDigits: 2, maximumFractionDigits: 2})
        },
        //取消事件
        handleClickCancel() {
            //关闭对话框
            this.$emit('update:productDetailVisible', false)
        },
        handleClickConfirm(){

        },

    },

}
</script>
<style lang="scss" scoped>
.text_align_right{
    ::v-deep .el-input__inner{
        text-align: right;
    }

}
@import "@/styles/product_shelves.scss";
</style>
